import React, { useCallback } from 'react';

import { CasinoGame } from '../../hooks/use-casino-games';
import { useCarouselCardSize } from '../../hooks/use-desktop-carousel';
import { CasinoLayoutProps } from '../../utils/utils';
import { CasinoGameCardBase } from '../CasinoGameCardBase';
import { DesktopCarousel } from './DesktopCarousel';

const VISIBLE_CARDS = 6;
/** Featured cards are portrait: 164 x 287 on the 1044 content grid. */
const CARD_ASPECT = 287 / 164;

const keyExtractor = (item: CasinoGame) => item.id;

export const FeaturedRowLayout = ({ data, layoutHeaderProps }: CasinoLayoutProps) => {
    const cardWidth = useCarouselCardSize(VISIBLE_CARDS);
    const cardHeight = cardWidth * CARD_ASPECT;

    const renderItem = useCallback(
        ({ item }: { item: CasinoGame }) => (
            <CasinoGameCardBase
                game={item}
                cardHeight={cardHeight}
                cardWidth={cardWidth}
                imageHeight={cardHeight}
                customTag={item.exclusive?.effective ? { label: 'Featured' } : undefined}
                customNameVariant="titleMedium"
            />
        ),
        [cardWidth, cardHeight]
    );

    return (
        <DesktopCarousel
            data={data}
            itemWidth={cardWidth}
            visibleCount={VISIBLE_CARDS}
            keyExtractor={keyExtractor}
            renderItem={renderItem}
            layoutHeaderProps={layoutHeaderProps}
            viewAllHeight={cardHeight}
        />
    );
};
